const gtagEventName = {
  register: "register",
};
export const gtagEventRegister = (uuid) => {
  window.dataLayer.push({
    event: gtagEventName.register,
    eui: uuid,
  });
};
